// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ead8831b","75":"94c30508","148":"31b295f7","497":"ca92baf4","853":"94cfa829","900":"c31b2ea0","963":"a6cf84b6"}[chunkId] + ".chunk.js";
};